import styled from "styled-components";

export const H1 = styled.h1`
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: ${({ theme }) => theme.typography.h1.fontSize};
  font-weight: ${({ theme }) => theme.typography.h1.fontWeight};
  color: ${({ theme }) => theme.colors.text};
  margin: 0;
`;

export const H2 = styled.h2`
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: ${({ theme }) => theme.typography.h2.fontSize};
  font-weight: ${({ theme }) => theme.typography.h2.fontWeight};
  color: ${({ theme }) => theme.colors.text};
  margin: 0;
`;

export const MediumHeader = styled.h2`
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: ${({ theme }) => theme.typography.h2.fontSize};
  font-weight: ${({ theme }) => theme.typography.medium.fontWeight};
  color: ${({ theme }) => theme.colors.text};
  margin: 0;
`;

export const BodyText = styled.p`
  font-family: ${({ theme }) => theme.fonts.body};
  font-size: ${({ theme }) => theme.typography.body.fontSize};
  font-weight: ${({ theme }) => theme.typography.body.fontWeight};
  color: ${({ theme }) => theme.colors.text};
  margin: 0;
`;

export const DangerText = styled.p`
  font-family: ${({ theme }) => theme.fonts.body};
  font-size: ${({ theme }) => theme.typography.medium.fontSize};
  font-weight: ${({ theme }) => theme.typography.medium.fontWeight};
  color: ${({ theme }) => theme.colors.danger};
  margin: 0;
`;

export const SuccessH2 = styled.h2`
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: ${({ theme }) => theme.typography.h2.fontSize};
  font-weight: ${({ theme }) => theme.typography.h2.fontWeight};
  color: ${({ theme }) => theme.colors.darkGreen};
  margin: 0;
`;

export const MediumText = styled.span`
  font-family: ${({ theme }) => theme.fonts.body};
  font-size: ${({ theme }) => theme.typography.medium.fontSize};
  font-weight: ${({ theme }) => theme.typography.medium.fontWeight};
  color: ${({ theme }) => theme.colors.text};
`;

export const SmallText = styled.span`
  font-family: ${({ theme }) => theme.fonts.body};
  font-size: ${({ theme }) => theme.typography.small.fontSize};
  font-weight: ${({ theme }) => theme.typography.small.fontWeight};
  color: ${({ theme }) => theme.colors.textSecondary};
`;

export const CardH1 = styled.h1`
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: 2.2rem;
  font-weight: ${({ theme }) => theme.typography.medium.fontWeight};
  color: ${({ theme }) => theme.colors.text};
  margin: 0;
`;

export const CardText = styled.span`
  font-family: ${({ theme }) => theme.fonts.body};
  font-size: ${({ theme }) => theme.typography.medium.fontSize};
  font-weight: ${({ theme }) => theme.typography.small.fontWeight};
  color: ${({ theme }) => theme.colors.textSecondary};
  white-space: nowrap;

  @media (max-width: 520px) {
    font-size: ${({ theme }) => theme.typography.small.fontSize};
  }
`;
